// extracted by mini-css-extract-plugin
module.exports = {"workspaceToggle":"WorkspaceToggle--workspace-toggle--1vcq-","workspaceTogglePosition":"WorkspaceToggle--workspace-toggle-position--3UdTl"};